import { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import './ExtensionInstallModal.css';

const ExtensionInstallModal = ({ open, onClose }) => {
  const [isExtensionInstalled, setIsExtensionInstalled] = useState(false);

  // Detect if the extension is already installed
  useEffect(() => {
    if (open) {
      setIsExtensionInstalled(!!window.__SUSU_CLOSET_EXTENSION__);
    }
  }, [open]);

  // Prevent body scroll when modal is open
  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  if (!open) return null;

  return ReactDOM.createPortal(
    <div
      className="extension-install-overlay"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="extension-install-content">
        {/* Icon */}
        <div className="extension-icon">
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#00b5ad" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" />
            <polyline points="14 2 14 8 20 8" />
            <path d="M12 18v-6" />
            <path d="M9 15l3-3 3 3" />
          </svg>
        </div>

        {/* Title + Description */}
        <h3 className="extension-title">SUSU Closet Browser Extension</h3>
        <p className="extension-description">
          Save clothes from any website directly to your closet with one click
        </p>

        {/* Install / Status */}
        {isExtensionInstalled ? (
          <div className="extension-installed-badge">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M3 8L7 12L13 4" stroke="#00b5ad" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            Extension installed
          </div>
        ) : (
          <button
            className="install-extension-btn"
            onClick={() => {
              window.open('https://chromewebstore.google.com/detail/susu-closet-%E2%80%94-save-virtua/fhpmbbpdllmcennoebifefaleedfifik', '_blank');
            }}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
              <polyline points="7 10 12 15 17 10" />
              <line x1="12" y1="15" x2="12" y2="3" />
            </svg>
            Add to Chrome
          </button>
        )}

        {/* Steps */}
        <div className="extension-steps">
          <div className="extension-step">
            <span className="step-number">1</span>
            <span className="step-text">Browse any fashion website</span>
          </div>
          <div className="extension-step">
            <span className="step-number">2</span>
            <span className="step-text">Right-click any clothing image</span>
          </div>
          <div className="extension-step">
            <span className="step-number">3</span>
            <span className="step-text">Select "Save to SUSU Closet"</span>
          </div>
        </div>

        {/* Reassurance */}
        {isExtensionInstalled ? (
          <p className="extension-note">
            Your saved items will appear automatically in your closet
          </p>
        ) : (
          <p className="extension-note">
            Free and lightweight -- works on any website
          </p>
        )}
      </div>
    </div>,
    document.body
  );
};

export default ExtensionInstallModal;

